import { ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Router } from '@angular/router';
import { _HttpClient } from '@delon/theme';

import { SelectInstantBaseComponent } from '../../selectInstant-base';

@Component({
  selector: 'app-wtax-code-select',
  templateUrl: './wtax-code-select.component.html',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => WTaxCodeSelectComponent),
      multi: true
    }
  ]
})
export class WTaxCodeSelectComponent extends SelectInstantBaseComponent {
  @Input() activeOnly = false;
  @Input() wvatOnly = false;
  constructor(http: _HttpClient, cdr: ChangeDetectorRef, router: Router) {
    super(http, cdr, router);
    this.valueField = '';
  }

  getUrl(searchValue: string): string {
    let url = `api/wtaxcodes/lookup?$skip=0&$orderby=code asc&$top=50`;
    let filter = ``;
    if (this.activeOnly) {
      filter = `isActive eq true`;
    }
    if (this.wvatOnly) {
      filter = `isActive eq true and isWithholdingVAT eq true`;
    }

    if (searchValue) {
      const searchStr = searchValue.replaceAll("'", "''");
      filter = `(${filter}) and (contains(code, '${encodeURIComponent(
        searchStr
      )}'))`;
    }

    return (url = `${url}&$filter=${filter}`);
  }

  get taxRate() {
    if (this.selected) {
      return this.selected.rate;
    }
    return 0;
  }

  jump(): string {
    return '';
  }

  queryParam(): String {
    return '';
  }

  taxCategoryMap: { [key: number]: string } = {
    0: '',
    1: 'Income Tax',
    2: 'Withholding Tax',
    3: 'Final Tax',
    4: 'Withholding VAT'
  };

  getTaxCategoryLabel(item: any): string {
    if (item.taxCategory) {
      return this.taxCategoryMap[item.taxCategory] || '';
    }

    if (item.isIncomeTax) return 'Income Tax';
    if (item.isWithholdingTax) return 'Withholding Tax';
    if (item.isFinalWTax) return 'Final Tax';
    if (item.isWithholdingVAT) return 'Withholding VAT';

    return 'Withholding Tax';
  }
}
